import './AuthLayout.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../../atoms/ComponentsWrapper';
import { canUseDOM, get, getMediaHost, injectImageResolution, pathJoin } from '../../../utils';
import LazyPicture from '../../atoms/LazyPicture';
import GoBackBtn from './GoBackBtn';
import { STEPS } from '../AccountAuthorization';
import { loaderStyles } from '../loaderStyles';
import RouterLink from '../../atoms/RouterLink';
const AuthLayout = _ref => {
  let {
    form,
    title,
    subTitle,
    image,
    allowRender = true,
    showLoader = false,
    cardsShown = false,
    activeStep,
    goBackLabel,
    handleClick = () => {},
    carouselShown,
    logoImage,
    logoLink
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const imagePath = get(image, 'jss.value.src');
  const imageAlt = get(image, 'jss.value.alt');
  const imageWidth = get(image, 'jss.value.width');
  const imageHeight = get(image, 'jss.value.height');
  const imageSrc = injectImageResolution(` ${pathJoin([getMediaHost(), imagePath])}`, imageWidth, imageHeight);
  const currentLang = get(sitecoreContext, 'language');
  const logoLinkHref = get(logoLink, 'url', `/${currentLang}`);
  const goToPrevPage = () => {
    if (canUseDOM) {
      window.history.back();
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, allowRender ? /*#__PURE__*/React.createElement(React.Fragment, null, showLoader && /*#__PURE__*/React.createElement("div", {
    className: "loader-t1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loadingio-spinner-rolling-arlp0sgzkfu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ldio-fryp34cx4ij"
  }, /*#__PURE__*/React.createElement("div", null)))), /*#__PURE__*/React.createElement("div", {
    className: "authlayout"
  }, get(logoImage, 'jss.value.src') && /*#__PURE__*/React.createElement("div", {
    className: "authlayout-logo"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "brands__link",
    href: logoLinkHref,
    title: get(logoImage, 'jss.value.alt'),
    ariaLabel: get(logoImage, 'jss.value.alt'),
    linktype: "external",
    openInSameTab: true
  }, /*#__PURE__*/React.createElement("span", {
    className: "accessibility-hidden-text",
    id: "dot-logo-title"
  }, get(logoImage, 'jss.value.alt')), /*#__PURE__*/React.createElement("img", {
    className: `brand rs_skip dot-logo`,
    alt: get(logoImage, 'jss.value.alt'),
    "aria-hidden": "true",
    src: get(logoImage, 'jss.value.src')
  }))), /*#__PURE__*/React.createElement("div", {
    className: `authlayout__left-bar ${cardsShown ? 'xl' : ''}`
  }, /*#__PURE__*/React.createElement(GoBackBtn, {
    label: goBackLabel,
    handleClick: () => {
      if (activeStep === STEPS.STEP1 || activeStep === STEPS.STEP5) {
        goToPrevPage();
      } else if (activeStep === STEPS.STEP6) {
        handleClick(STEPS.STEP1);
      } else {
        handleClick();
      }
    },
    isFormStepBack: true
  }), /*#__PURE__*/React.createElement("h2", {
    className: `authlayout-main-title ${carouselShown ? 'carousel' : ''}`,
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "authlayout-subtitle",
    dangerouslySetInnerHTML: {
      __html: subTitle
    }
  }), form), /*#__PURE__*/React.createElement("div", {
    className: `authlayout-image-item ${carouselShown ? 'carousel' : ''}`
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    style: {
      width: '100%',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imageSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "marker-info-item__image",
    src: imageSrc,
    alt: imageAlt,
    "aria-hidden": "true"
  }))))) : null);
};
const mainStyles = "m10y6ipe";
const mainRtlStyles = "m2qc5v2";
const mainLtrStyles = "m1gj21xm";
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${loaderStyles} ${mainStyles}  ${rtl ? mainRtlStyles : mainLtrStyles} `
  }, children);
};
export default AuthLayout;